import { usePublicFeatureFlags } from '@/shared/api/featureFlagsQueries'

export function useColonyFeatureFlag(): { enabled: boolean; isLoading: boolean } {
  const flagsQuery = usePublicFeatureFlags()
  return {
    enabled: flagsQuery.data?.find((row) => row.module_name === 'colony')?.enabled === true,
    isLoading: flagsQuery.isPending,
  }
}

export function useColonyEnabled(): boolean {
  return useColonyFeatureFlag().enabled
}
